<template>
    <div class='apply'>
        <div class="title":class="$vuetify.theme.dark ? '': 'sub-title-l'">{{$t('preference.apply.title')}}</div>
        <div id="apply" style="flex: 1;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { reportApp } from "@/api/index";
import monent from 'moment'
import store from '@/store'

export default {
    data() {
        return {

        };
    },
    props:{
        filterQuery:{
          type:Number,
          default:1
      }
    },
    watch:{
        filterQuery:{
           handler:function (val, oldVal) {
                this.initApply()
            },
        }

    },
    mounted() {
            this.initApply()
    },
    methods: {
        initApply(){
            let startTime = monent().subtract(1,'w').startOf('days').unix()
            let endTime = monent().endOf('days').unix()
            // let endTime = new Date(new Date().toLocaleDateString()).getTime()+8640000
            if(this.filterQuery == 1){
                startTime = monent().subtract(6,'days').startOf('days').unix()
            }
            if(this.filterQuery == 2){
                startTime = monent().subtract(13,'days').startOf('days').unix()
            }
            if(this.filterQuery == 3){
                startTime = monent().subtract(20,'days').startOf('days').unix()
            }
            if(this.filterQuery == 4){
                startTime = monent().subtract(29,'days').startOf('days').unix()
            }
            if(this.filterQuery == 5){
                startTime = monent().subtract(59,'days').startOf('days').unix()
            }
            if(this.filterQuery == 6){
                startTime = monent().subtract(89,'days').startOf('days').unix()
            }
            // if(this.filterQuery < 4) {
            //     startTime = monent().subtract(this.filterQuery,'w').startOf('days').unix()
            // }else{
            //     let startNum = this.filterQuery - 3
            //     startTime = monent().subtract(startNum,'M').startOf('days').unix()
            // }

            let params = {
                startTime:startTime,
                endTime:endTime
            }
            reportApp(params).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    // let res = {code: 200, message: "查询成功", data: [{name: "邮箱6太原dsdf人33444446登录", value: 1},{name: "邮箱757好的登录", value: 1},{name: "邮箱8塔尔8登录", value: 1},{name: "邮箱9贴9登录", value: 1},{name: "邮箱1贴0登录", value: 1},{name: "邮箱塔尔11登录", value: 1},{name: "邮箱tertiary636登录", value: 1},{name: "邮箱7贴贴57登录", value: 1},{name: "邮箱88贴贴登录", value: 1},{name: "邮箱99登录", value: 1},{name: "邮箱10登录", value: 1},{name: "邮箱11登录", value: 1},{name: "邮箱12登录", value: 1},{name: "邮箱13登录", value: 1},{name: "邮箱14登录", value: 1}]}

                    this.setEcharts(res.data)
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },

        setEcharts(data) {
            for(var i=0;i<data.length-1;i++){
                //2.指定轮数和次数（内循环控制次数）
                for(var j=0;j<data.length-1;j++){
                    //3.判断是否符合标准。如果符合标准交换位置。
                    //从小到大排列顺滑，如果前面的比后面的大，那么交换位置。
                    if(data[j].value < data[j+1].value){
                        var temp = data[j];
                        data[j] = data[j+1];
                        data[j+1] = temp;
                    }
                }
            }

            var chartDom = document.getElementById('apply');
            var myChart = echarts.init(chartDom);
            var option = {
                tooltip: {
                    trigger: 'item',
                    position: ['12%', '82%'],
                    formatter: '{b}('+this.$t('preference.num')+'): {c} ({d}%)',
                    // formatter: '{b}('+this.$t('preference.num')+'): {c}<br/> ({d}%)'
                },
                legend: {
                    formatter: function(name){
                    　　　　return name.length > 7 ? name.substr(0,7)+"..." : name;
                　　},
                    type: 'scroll', //可滚动翻页的图例
                    pageIconSize: 9, //翻页按钮大小
                    pageIconColor: '#5066e0', //翻页箭头颜色
                    pageTextStyle:{
                        color:this.$vuetify.theme.dark ? '#9994b0' : '#000'
                    },
                    left:'62%',
                    bottom: '2%',
                    icon:"circle",
                    orient:'vertical',
                    type: 'scroll',
                    padding: [20,20,20,0],
                    textStyle: {
                        color: this.$vuetify.theme.dark ? '#9994b0' : '#000'
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['30%', '60%'],
                        center: ["33%", "50%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                            formatter: function(name){
                                let title = name.data.name
                                var newStr=" ";
                                var start,end;
                        　　　　 var name_len = title.length;    　　　　　　　　　　　　   //每个内容名称的长度
                        　　　　 var max_name = 8;    　　　　　　　　　　　　　　　　　　//每行最多显示的字数
                        　　　　 var new_row = Math.ceil(name_len / max_name); 　　　　// 最多能显示几行，向上取整比如2.1就是3行
                        　　　　 if(name_len > max_name){ 　　　　　　　　　　　　　　  //如果长度大于每行最多显示的字数
                        　　　　　　for(var i = 0;i < new_row;i++){ 　　　　　　　　　　　   //循环次数就是行数
                        　　　　　　　　var old = '';    　　　　　　　　　　　　　　　　    //每次截取的字符
                        　　　　　　　　start = i * max_name;    　　　　　　　　　　     //截取的起点
                        　　　　　　　　 end = start + max_name;    　　　　　　　　　  //截取的终点
                        　　　　　　　　if(i == new_row-1){    　　　　　　　　　　　　   //最后一行就不换行了
                            　　　　　　　　　　old = title.substring(start);
                        　　　　　　　　}else{
                            　　　　　　　　　　old = title.substring(start,end) + "\n";
                        　　　　　　　　 }
                        　　　　　　　　　　 newStr += old; //拼接字符串
                        　　　　　　  }
                        　　　   }else{                                          //如果小于每行最多显示的字数就返回原来的字符串
                        　　　　　　newStr = title;
                        　　　  }
                        　　　 return newStr;
                            },
                            textStyle:{       //这只是为了让文字居中而已
                            　　align:"center",            //水平对齐方式可选left，right，center
                            　　baseline:"top",　　　　//垂直对齐方式可选top，bottom，middle
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '17',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        itemStyle: {
                            normal: {
                                color: function (colors) {
                                    var colorList = [
                                        '#5066ed',
                                        '#02d7ff',
                                        '#00d48f',
                                        '#ff8c00',
                                        '#fa5c7c',
                                        '#ffc107',
                                        '#f5222d',
                                        '#a0d911',
                                        '#EC407A',
                                        '#8E24AA',
                                        '#673AB7',
                                        '#3F51B5',
                                        '#2196F3',
                                        '#4CAF50',
                                        '#CDDC39',
                                        '#FFEB3B',
                                        '#FFC107',
                                        '#FF9800',
                                        '#795548',
                                        '#607D8B',
                                    ];
                                    return colorList[colors.dataIndex];
                                }
                            },
                        }
                    },
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>

<style lang='scss' scoped>
.apply {
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 500;
        padding-left: 33px;
        border-bottom: 1px solid #F0F0F0;
    }
    .sub-title-l {
        color: #031b4e;
    }
}
</style>
